export const API_URL = `https://dev6.dansmultipro.com/api/recruitment/positions`;
